import { Box } from "@mui/material";
import React, { useRef } from "react";
import { useInView } from "framer-motion";
import { roomSelector } from "../../features/rooms/roomSlice";
import { useDispatch, useSelector } from "react-redux";
import { removeRoomCount } from "../../features/rooms/roomSlice";
import { removeCostItemsAndUpdateList } from "../../features/costSummary/costSummarySlice";
function CustomBox({ sx, className, darkMode, children, index, showRemoveButton, ...props }) {
  const dispatch = useDispatch();
  const ref = useRef(null);
  const isInView = useInView(ref);
  return (
    <>
    <Box
      {...props}
      ref={ref}
      sx={{
        transitionDelay: "0.150s",
        transitionDuration: "2s",
        maxWidth: {
          xs: "500px",
        },
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto",
        bgcolor: darkMode ? "rgb(var(--color-nav-bg))" : "rgb(var(--color-surface))",
        ...sx,
        // transform:isInView?'translateY(0px)':'translateY(25px)',
        // opacity: isInView ? `1` : `0.7`,
      }}
      // -translate-5px
      className={`${className}  
      ${darkMode ? `text-on-primary` : `border-black border-[0.5px]`} rounded-card`}
    >
      {children}
    </Box>
    {showRemoveButton && 
      <Box
      sx={{
        maxWidth: {
          xs: "500px",
        },
        transitionDelay: "0.150s",
        transitionDuration: "2s",
        width: "100%",
        marginTop: "10px",
        marginBottom: "0px",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <button
        onClick={() =>{
          dispatch(removeRoomCount(index));
          dispatch(removeCostItemsAndUpdateList(index));
        }}
        className="mt-[10px] mb-[0px] text-accent-text text-[13px] font-light uppercase cursor-pointer w-full text-right"
        title="Remove room"
      >
        X Remove
      </button>
    </Box>
  }
    </>
  );
}

export default CustomBox;
